module.exports = __webpack_public_path__ + "img/life-project.a0e376d5.jpg";